import { createApp } from 'vue'
import App from './App.vue';
import IButton from '@/UI/IButton.vue';
import landingText from '@/config/landing-text.json';
import router from '@/router';


const app = createApp(App);

app.config.globalProperties.$landingText = landingText;

app
    .component('IButton', IButton)
    .use(router)
    .mount('body');
